import * as React from "react"

const TabsContainer: React.FC = ({ children }) => {
  return <div className="w-full flex items-center justify-center">{children}</div>
}

export default TabsContainer
